import { useCallback, useEffect, useState } from "react";

import { notify } from "utils/notify";

/**
 * The portal's image CAPTCHA for a form: GET /login/captcha on mount, and again on refresh.
 *
 * The server spends a CAPTCHA on every submission that names it, right or wrong, so a form asks
 * for a fresh one after a failed submission (refresh). `captcha.id` and what the visitor typed
 * go with the form as captcha_id and captcha_input.
 */
const useCaptcha = () => {
  const [captcha, setCaptcha] = useState({ url: "", id: "" });

  const refresh = useCallback(async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/login/captcha`
      );
      const data = await response.json();
      setCaptcha({
        url: `data:image/png;base64,${data.image}`,
        id: data.captcha_id,
      });
    } catch (error) {
      console.error("Failed to fetch CAPTCHA:", error);
      notify.error("UI_CAPTCHA_LOAD_FAILED");
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { captcha, refreshCaptcha: refresh };
};

export default useCaptcha;
